const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import { useMutualAvailabilityEnabled } from 'components/mutual_availability/use_mutual_availability_enabled'
import { useMutualAvailabilityLoginEnabled } from 'components/mutual_availability/use_mutual_availability_login_enabled'

import Info from './info'
import Login from './login'
import _Container from "index-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/mutual_availability_notice/index.js?styleId=Container";



const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp')
  })
})

const Notice = () => {
  const isMutualAvailabilityEnabled = useMutualAvailabilityEnabled()
  const isMutualAvailabilityLoginEnabled = useMutualAvailabilityLoginEnabled()
  if (!isMutualAvailabilityEnabled && !isMutualAvailabilityLoginEnabled) return null

  return (
    <Container>
      {isMutualAvailabilityEnabled && <Info />}
      {isMutualAvailabilityLoginEnabled && <Login />}
    </Container>
  )
}

export default Notice
